import { ref, computed, watch } from 'vue'
import { useStore } from '@/store'

export const useLoggedInPlanner = () => {
  const onLoggedInPlannerInitializedHandler = ref<() => void>(() => {
    /* noop */
  })
  /**
   * - ログイン後
   * - ページリロード後のplanner sessionがvalidであることが確認された時
   */
  const onLoggedInPlannerInitialized = (handler: () => void) => {
    onLoggedInPlannerInitializedHandler.value = handler
    checkStatusIsLoggedIn(isLoggedIn.value)
  }

  const onLoggedOutHandler = ref<() => void>(() => {
    /* noop */
  })
  const onLoggedOut = (handler: () => void) => {
    onLoggedOutHandler.value = handler
  }

  const store = useStore()

  const isLoggedIn = computed<boolean>(() => store.getters.isLoggedIn)
  // FIXME: beforeがundefinedでもたまたま動くようになっている。storeを丸ごとhooksに移したらちゃんと作る
  const checkStatusIsLoggedIn = (after: boolean, before?: boolean) => {
    if (after && !before) {
      onLoggedInPlannerInitializedHandler.value()
    }
  }
  const checkStatusIsLoggedOut = (after: boolean, before?: boolean) => {
    if (!after && before) {
      onLoggedOutHandler.value()
    }
  }
  const onLoggedInStatusChanged = (after: boolean, before?: boolean) => {
    checkStatusIsLoggedIn(after, before)
    checkStatusIsLoggedOut(after, before)
  }
  watch(isLoggedIn, onLoggedInStatusChanged)

  return {
    isLoggedIn,
    onLoggedInPlannerInitialized,
    onLoggedOut,
  }
}
